import React, { useEffect, useRef, useState } from "react";
import label from "../../labels/administration_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import moment from "moment";

import { DatePicker, Space } from "antd";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import dayjs from "dayjs";
import {
  getAdvertisementlistByYear,
  getAlphabeticalList,
  getYearList,
} from "../../../common/actions/commonActions";
import { getExamslistByAdvertisementId } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { SET_ALPHABETICAL_LIST } from "../../../common/constants/ActionTypes";
const BlacklistedCandidate = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });
  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    setReloadItem(!reloadItem);
  }, []);
  const dispatch = useDispatch();
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const [selectedExam, setSelectedExam] = useState("");
  let [selectedAdvert, setSelectedAdvert] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  let { yearList, allYearList, alphabeticallist } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let { examList, advertisementList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  useEffect(() => {
    dispatch({
      type: SET_ALPHABETICAL_LIST,
      payload: [],
    });
  }, []);
  const onCancelButton = () => {
    reset();
    dispatch({
      type: SET_ALPHABETICAL_LIST,
      payload: [],
    });
  };

  const onSubmit = () => {
    dispatch(getAlphabeticalList(setPrintFlag));
    // setPrintFlag(false);
    setReloadItem(!reloadItem);
  };
  const downloadPdf = () => {
    genPdf();
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    if (allYearList) {
      allYearList.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }
    dispatch({
      type: SET_ALPHABETICAL_LIST,
      payload: [],
    });
    setPrintFlag(true);
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvert(selectedValue);
    setSelectedExam("");
    examList.length = 0;
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setPrintFlag(true);
    dispatch({
      type: SET_ALPHABETICAL_LIST,
      payload: [],
    });
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    setSaveButtonFlag(false);
    setPrintFlag(true);
    dispatch({
      type: SET_ALPHABETICAL_LIST,
      payload: [],
    });
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5>' +
      commonLabels.MPSC +
      "</h5><h5>" +
      commonLabels.AlphabeticalList +
      "</h5></div>";
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "Blacklisted_Candidate.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = "";
          const headerText = `${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`Blacklisted_Candidate.pdf`);
      });
  };
  return (
    <div className="dashboardContentArea">
      <h5> {label.Blacklisted} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option>{element}</option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                <div className="form-group col-md-4">
                  <label className="float-left">
                    {commonLabels.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index + 1} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-8">
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary" ||
                    session.roleName == "desk officer") && (
                      <>
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag}
                          onClick={handleSubmit((e) => {
                            onSubmit(e);
                            setConfirmClicked(true);
                          })}
                        >
                          {commonLabels.BUTTON_VIEW}
                        </button>
                      </>
                    )}
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary" ||
                    session.roleName == "desk officer") && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        disabled={printFlag || !confirmClicked}
                        onClick={() => {
                          downloadPdf();
                        }}
                      >
                        {commonLabels.BUTTON_PRINT}
                      </button>
                    )}
                </div>
              </div>
            </div>
          </form>
        </div>
        {alphabeticallist && alphabeticallist.length > 0 && (
          <div
            ref={pdfRef}
            className="answerKeyTable w-100"
            id="blacklisted_candidate"
          >
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th className="text-center col-1">{label.Srno}</th>
                  <th className="col-4">{label.CandidateName}</th>
                  <th className="col-4">{label.MotherName}</th>
                  <th className="col-3">{label.UpdateDataFromDate}</th>
                </tr>
              </thead>
              <tbody>
                {alphabeticallist &&
                  alphabeticallist.length > 0 &&
                  alphabeticallist.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        <td>{item.candidateName}</td>
                        <td>{item.motherName}</td>
                        <td>
                          {item.dob
                            ? moment(item.dob).format("DD/MM/YYYY")
                            : ""}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlacklistedCandidate;
